<template>
    <div class="ml-auto">
        <nav class="navbar navbar-expand-lg markers-nav p-0" v-if="!loading">
            <button class="btn btn-outline-notiblue white d-md-none d-lg-none d-xl-none" type="button" data-toggle="markers-modal" @click="showModal">
                {{translate('messages.markers')}}
            </button>
            
            <ul class="navbar-nav mr-auto d-none d-md-flex d-lg-flex d-xl-flex">
                <li class="nav-item dropdown mx-1" v-for="marker_category in marker_categories" :key="'marker-category-nav-'+marker_category.id">
                    <a class="nav-link dropdown-toggle px-3" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{marker_category.name}}
                    </a>
                    <div class="dropdown-menu p-1" aria-labelledby="navbarDropdown">
                        <a v-for="marker in marker_category.markers" :key="'marker-'+marker.id" :href="marker.url" class="btn btn-outline-notiblue btn-block my-2 white" target="_BLANK">{{marker.name}}</a>
                    </div>
                </li>
            </ul>
        </nav>
        <div class="modal fade full-modal" id="markers-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog m-0" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{translate('messages.markers')}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true"><i class="fas fa-times"></i></span>
                        </button>
                    </div>
                    <div class="modal-body p-4" id="result">
                        <ul class="nav nav-sidebar nav-pills flex-column markers-tree-nav" data-widget="treeview" role="menu" data-accordion="false" id="markers-tree-nav">
                            <li class="nav-item has-treeview mb-3" v-for="marker_category in marker_categories" :key="'marker-category-tree-'+marker_category.id">
                                <a class="nav-link btn btn-outline-notiblue m-0">
                                    <p class="h5 m-0">
                                        {{marker_category.name}}
                                        <i class="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item ml-2" v-for="marker in marker_category.markers" :key="'marker-tree-'+marker.id">
                                        <a class="nav-link pl-4 h5 m-0" :href="marker.url" target="_BLANK" >
                                            {{marker.name}}
                                        </a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
 
<script>
export default {
    data () {
        return {
            marker_categories : [],
            loading : true,
        }
    },
    methods: {
        loadMarkerCategories(){
            axios.get("/api/markerCategory/all").then(({ data }) => {
                this.marker_categories = data.data; this.loading = false;
            });
        },
        showModal(){
            $('#markers-modal').modal('show');
        }
    },
    mounted() {
        this.$root.$on('updateMarkersNavbar', () => {
            this.loadMarkerCategories();
        });
    },
    created() {
        if(this.$gate.hasFeaturePermission('markers')) this.loadMarkerCategories();
    },
    watch: {
        marker_categories(){
            this.$forceUpdate();
        }
    }
}
</script>